/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setNearbyPrivacyPreference} from '../api'

export const useMutationSetNearbyPrivacyPreference = createReactQueryMutationHook('setNearbyPrivacyPreference', setNearbyPrivacyPreference)
